import * as services from '@/services'

export default {
  namespaced: true,

  state: {
    user: null
  },

  getters: {
    isAdmin: state => state.user?.role === 'admin',
    isOnboarded: state => Boolean(state.user?.quizString),
    isPremium: state => state.user?.isPremium
  },

  actions: {
    async UPDATE_SECTION_RECORDS({ commit }, payload) {
      const { isSuccess, content } = await services.users.updateSectionRecords(
        payload
      )

      if (!isSuccess) return { isSuccess }

      commit('SET_USER', content.user)

      return { isSuccess }
    },

    async UPDATE_QUIZ_STRING({ commit }, payload) {
      const { isSuccess, content } = await services.users.updateQuizString(
        payload
      )

      if (!isSuccess) return { isSuccess }

      commit('SET_USER', content.user)

      return { isSuccess, content }
    }
  },

  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    UPDATE_USER(state, toUpdate) {
      state.user = { ...state.user, ...toUpdate }
    }
  }
}
